import React from 'react';
import {theme} from "theme";
import {useTranslation} from "react-i18next";
import "./styles.css";

const NoResults = () => {
    const {t} = useTranslation();
    return (
        <div style={{color: theme.color.secondary}} className="event-search-list-no-results">
            <h1>
                ¯\_(ツ)_/¯
            </h1>
            <p>
                {t('event.search.list.events.not.found')}
            </p>
        </div>
    )
}

export default NoResults;